<template>
  <button :class="getButtonClasses()" :disabled="disabled" @click="handleClick">
    <i v-if="icon" :class="getIconClasses()" />
    <span :class="{'sr-only': iconOnly}">
      {{ text }}
    </span>
  </button>
</template>
<script>

export default {
  name: 'W2HButton',
  // Vue 3:
  // emits: ['click'],
  props: {
    type: {
      type: String,
      default: 'primary',
      validator(value) {
        return ['primary', 'secondary', 'danger', 'link'].includes(value);
      }
    },
    size: {
      type: String,
      default: 'md',
      validator(value) {
        return ['sm', 'md', 'lg'].includes(value);
      }
    },
    text: {
      type: String,
      required: true,
    },
    // Font Awesome icon class (part after the hyphen), e.g. "trash"
    icon: {
      type: String,
      default: null,
    },
    iconFill: {
      type: String,
      default: 'fas',
      validator(value) {
        return ['fa', 'fas'].includes(value);
      }
    },
    // Hides the text visually, but shows it to screen readers
    iconOnly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getButtonClasses() {
      const classes = ['btn'];
      classes.push(`btn-${this.type}`);
      if(this.size !== 'md') {
        classes.push(`btn-${this.size}`);
      }
      return classes;
    },
    getIconClasses(){
      return [this.iconFill, `fa-${this.icon}`];
    },
    handleClick(event) {
      if (!this.disabled) {
        this.$emit('click', event);
      }
    },
  },
}
</script>
